module.exports = __webpack_public_path__ + "static/img/spike_benefits_topimage.58a6f1b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity/miaosha/spike_benefits_topimage.png
// module id = u8QY
// module chunks = 0